import { Component } from '@angular/core';
import { NavigationService } from '@fgb/portal-component-library/src/lib/shared/services';
import { ProductCode } from 'src/app/shared/utilities/product-code';

@Component({
  selector: 'fgb-games-page',
  templateUrl: './games-page.component.html',
  styleUrl: './games-page.component.scss',
})
export class GamesPageComponent {
  productCode = ProductCode;

  constructor(
    private navigationService: NavigationService
  ) { }

  ngOnInit(): void {
    this.navigationService.hideMobileNav();
  }

  ngOnDestroy(): void {
    this.navigationService.showMobileNav();
  }
}